// extracted by mini-css-extract-plugin
export default {"splashScreen":"SplashScreen_splashScreen__B5I9w"};